import React from 'react';

import { TooltipIcon } from '~components';
import { faTriangleExclamation } from '~components/icon';

import { PaymentBatchClient } from '~direct-debits/models';

interface ComponentProps {
  row: PaymentBatchClient;
}

const RETRY_TOOLTIP =
  "This payment's status is still 'submitted' because it failed on the GoCardless side but has been " +
  'scheduled for an automatic retry — see the new Next Charge Date.';

// Flags a line whose GoCardless payment failed but is scheduled for an automatic
// retry — it stays `submitted`, so the icon is what tells it apart from a healthy
// in-flight line. Nothing renders when the line never failed or is terminal
// (`retry_scheduled` is false in both cases).
const BatchClientRetryAlertCell: React.FC<ComponentProps> = ({ row }) => {
  if (!row.retry_scheduled) return null;
  return (
    <TooltipIcon
      id={`dd-batch-retry-alert-${row.client_id}`}
      icon={faTriangleExclamation}
      tooltip={RETRY_TOOLTIP}
      iconColor="orange"
    />
  );
};

export default BatchClientRetryAlertCell;
